import { render, staticRenderFns } from "./intergroupList.vue?vue&type=template&id=997452de&scoped=true"
import script from "./intergroupList.vue?vue&type=script&lang=js"
export * from "./intergroupList.vue?vue&type=script&lang=js"
import style0 from "./intergroupList.vue?vue&type=style&index=0&id=997452de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997452de",
  null
  
)

export default component.exports